<template>
  <v-menu left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on">
        <v-icon> mdi-dots-horizontal </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="setStatusUser(item.status)"
        :disabled="selfSuspended || item.status == status_user"
      >
        <v-list-item-avatar height="14">
          <v-icon :color="handleColorStatus(item.status)" size="16">
            mdi-circle
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-title class="body-2">
          <strong>{{ item.title }}</strong>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: "components-administrator-status-user-menu-dropdown",
  props: [
    "id_user",
    "status_user",
    "suspendUser",
    "user_level",
    "selfSuspended",
  ],
  data: () => ({
    status: "",
    hidePendingStatus: false,
  }),
  mounted() {
    if (
      this.$route.name == "AdministratorUsersPlayersSearch" ||
      this.$route.name == "ListPlayersOnline" ||
      this.$route.name ==
        "AdministratorAccountabilityOnlinePlayersOnlineSearch" ||
      this.$route.name == "CollaboratorAccountabilityOnlinePlayersOnlineSearch"
    ) {
      this.hidePendingStatus = true;
    }
  },
  computed: {
    actionConfirm() {
      return this.$store.state.actionConfirm;
    },
    items() {
      if (
        this.$route.name === "ListPlayersOnline" ||
        this.$route.name === "CollaboratorListPlayersOnline"
      ) {
        const statusArr = [
          {
            title: this.$t("activate"),
            status: "1",
          },
        ];
        return statusArr;
      } else {
        const statusArr = [
          { title: this.$t("activate"), status: "1" },
          { title: this.$t("supend"), status: "0" },
          { title: this.$t("disable"), status: "3" },
        ];

        if (!this.hidePendingStatus) {
          statusArr.push({ title: this.$t("pending"), status: "2" });
        }

        return statusArr;
      }
    },
    updatingPlayer() {
      return (
        this.$route.name == "AdministratorUsersPlayersSearch" ||
        this.$route.name == "ListPlayersOnline" ||
        this.$route.name ==
          "AdministratorAccountabilityOnlinePlayersOnlineSearch" ||
        this.$route.name ==
          "CollaboratorAccountabilityOnlinePlayersOnlineSearch"
      );
    },
  },
  watch: {
    actionConfirm(val) {
      if (val && this.status == 3) {
        this.changeStatus();
      }
    },
  },
  methods: {
    setStatusUser(status) {
      // Com o jogador auto-suspenso, não é possível mudar o status dele
      if (this.selfSuspended) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("changingStatusOfSelfSuspendedPlayer"),
          color: "error",
        });

        return;
      }

      this.status = status;

      // Alert: Status 3 "DESATIVAR"!!
      // Alertar o usuário para confirmação dessa ação
      // if (this.status == "3" && !this.actionConfirm) {
      //     this.$store.commit("setFeedbackDialog", {
      //     title: "Atenção",
      //     msg:
      //       "Esta ação só poderá ser desfeita abrindo um Ticket com o suporte. Você deseja confirmar ?",
      //     type: "warning",
      //     action: "confirm",
      //   });
      // }

      // Se o usuário for jogador, ativa um modal para inserção do motivo da suspensão/desativação
      if ((status == 3 || status == 0) && this.user_level == "player") {
        // Função para abrir o modal
        this.$emit("suspendUser", status);
      } else {
        this.changeStatus();
      }
    },
    async changeStatus(reason = null) {
      if (
        this.$route.name === "ListPlayersOnline" ||
        this.$route.name === "CollaboratorListPlayersOnline"
      ) {
        this.$emit("setLoading", true);
      }

      const body = {
        id_user: this.id_user,
        status: this.status,
        domain: this.$localStorage.getItem("user_data").db_name,
      };

      if (reason) {
        body["reason"] = reason;
      }

      const isCollaborator = JSON.parse(localStorage.getItem("user_data"))
        .isCollaborator;

      const player = this.updatingPlayer ? "players" : "user";

      const endpoint = isCollaborator
        ? `colab/${player}/changeStatus`
        : `administrator/${player}/changeStatus`;

      const response = await this.$request.post(endpoint, body);

      if (response.length !== 0) {
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      }

      this.$store.commit("setRefresh", true);
      this.$store.commit("setActionConfirm", false);

      if (
        this.$route.name === "ListPlayersOnline" ||
        this.$route.name === "CollaboratorListPlayersOnline"
      ) {
        this.$emit("setLoading", false);
      }
    },
    // handle color status
    handleColorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },
  },
};
</script>
